import { render } from "./PieComponent.vue?vue&type=template&id=37cf9fd2&ts=true"
import script from "./PieComponent.vue?vue&type=script&lang=ts"
export * from "./PieComponent.vue?vue&type=script&lang=ts"

import "./PieComponent.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__